import { FeatureFlag } from '@/types/featureFlag';
import { useFeatureFlagsEnabledQuery } from '@/utils/useFeatureFlagEnabled';

const LEGACY_PATIENT_AVAILABILITY_FLAGS = {
    showLegacyPatientAvailability: FeatureFlag.DASHBOARD_SHOW_LEGACY_PATIENT_AVAILABILITY,
    patientDetailsPageV2: FeatureFlag.PATIENT_DETAILS_PAGE_V2,
};

/* Whether to show legacy patient availability (patient time preferences): always for orgs on
 * the legacy patient details page, and for orgs on the v2 page only with the legacy
 * availability flag on. Hidden until the flags load, so v2 orgs never see it flash in.
 */
export const useShowLegacyPatientAvailability = (): boolean => {
    const { enabled, loading } = useFeatureFlagsEnabledQuery(LEGACY_PATIENT_AVAILABILITY_FLAGS);

    return !loading && (enabled.showLegacyPatientAvailability || !enabled.patientDetailsPageV2);
};
